import React from 'react';
import { Maximize2, RefreshCw, Trash2 } from 'react-feather';
import LogoPreview from './LogoPreview';
import Tooltip from '../popups/Tooltip';

const UploadedState = ({ logo, onReplace, onRemove, onView }) => (
	<div className="image-upload-control__uploaded">
		<div className="image-upload-control__uploaded-preview-wrap">
			<LogoPreview src={logo.src} alt={logo.name || logo.file} height={104} />
			<button
				type="button"
				className="image-upload-control__expand-btn"
				onClick={onView}
				aria-label="View logo at full size"
			>
				<Maximize2 size={15} />
			</button>
		</div>
		<div className="image-upload-control__uploaded-info">
			<div>
				<div className="image-upload-control__uploaded-name" title={logo.name || logo.file}>
					{logo.name || logo.file || 'Logo'}
				</div>
				<div className="image-upload-control__uploaded-meta">
					{logo.size && <span>{logo.size}</span>}
					{logo.dims && <span>{logo.size ? '· ' : ''}{logo.dims}</span>}
				</div>
			</div>
			<div className="image-upload-control__uploaded-actions">
				<Tooltip label="Replace logo" placement="top" delay={500}>
					<button
						type="button"
						className="image-upload-control__action-btn is-icon"
						onClick={onReplace}
						aria-label="Replace logo"
					>
						<RefreshCw size={15} />
					</button>
				</Tooltip>
				<Tooltip label="Remove logo" placement="top" delay={500}>
					<button
						type="button"
						className="image-upload-control__action-btn is-icon is-danger"
						onClick={onRemove}
						aria-label="Remove logo"
					>
						<Trash2 size={15} />
					</button>
				</Tooltip>
			</div>
		</div>
	</div>
);

export default UploadedState;
